import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import momentJalaali from 'moment-jalaali';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-load-watch-voltage-current',
  templateUrl: './load-watch-voltage-current.component.html',
  styleUrls: ['./load-watch-voltage-current.component.css', '../load-watch-performance/load-watch-performance.component.css']
})

export class LoadWatchVoltageCurrentComponent implements OnInit {
  reportVoltage: any;
  totalRunTimeSec: number = 0;
  totalLowVoltageCount: number = 0;
  totalHighVoltageCount: number = 0;
  totalLowFrequencyCount: number = 0;
  totalHighFrequencyCount: number = 0;
  strTotalRunTimeSec: string = '';

  searchForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    strIMEI: new FormControl(''),
    strSDate: new FormControl(momentJalaali().subtract(30, 'day').format('jYYYY/jMM/jDD')),
    strEDate: new FormControl(momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD')),
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.parent?.params['id'];

    this.searchForm.patchValue({
      strIMEI: id
    })

  }

  fetchData = async (showLoading: boolean = true) => {
    let model = this.searchForm.value;

    if (showLoading) {
      this._other.Showspinner()
    }

    let res = JSON.parse((await axios.post(`LoadWatch_DailyReport_Performance`, this._other.stringNumberToNumber(model))).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.reportVoltage = res;
    this.calculateTotals();

  }

  calculateTotals() {
    this.totalRunTimeSec = 0;
    this.totalLowVoltageCount = 0;
    this.totalHighVoltageCount = 0;
    this.totalLowFrequencyCount = 0;
    this.totalHighFrequencyCount = 0;

    for (const item of this.reportVoltage) {
      this.totalRunTimeSec += parseInt(item.iRunTimeSec ?? 0);
      this.totalLowVoltageCount += parseInt(item.iLowVoltageCount ?? 0);
      this.totalHighVoltageCount += parseInt(item.iHighVoltageCount ?? 0);
      this.totalLowFrequencyCount += parseInt(item.iLowFrequencyCount ?? 0);
      this.totalHighFrequencyCount += parseInt(item.iHighFrequencyCount ?? 0);
    }

    this.strTotalRunTimeSec = this.secondsToHMS(this.totalRunTimeSec);
  }

  secondsToHMS(totalSeconds: any) {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  exportExcel(): void {
    let element = document.getElementById("Export_Excel");
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'ولتاژ و جریان.xlsx');
  }

}
